export class AccountCreationConfigItem {
    Name: string;
    Visible: boolean;
    Required: boolean;
    Text: string;
    Roles: string;
}